/** Deve coincidir com index.html (GTM + gtag + Meta Pixel). */
export const GTM_CONTAINER_ID = 'GTM-WKMN9CBV'
export const GA_MEASUREMENT_ID = 'G-DZ6XC3NZ11'

/* Meta Pixel — base code carregado em index.html, eventos custom
   despachados via src/lib/meta-pixel.js. PageView por SPA navigation
   é disparado em src/router/index.js. */
export const META_PIXEL_ID = '1167205920639595'

/* Make.com — webhook que recebe o payload completo do Lead (form +
   click IDs + cookies do Pixel + UTMs + contexto) e é responsável
   por chamar a Conversions API do Meta server-side, fora deste repo.
   A URL é semi-pública (qualquer um pode chamar); o cenário do Make
   deve validar o payload (campos obrigatórios) e/ou aceitar só os
   domínios esperados via header Origin. */
export const MAKE_LEAD_WEBHOOK_URL = 'https://hook.us2.make.com/na838axf8hd4gq5viaiatrva2scpegua'
